import { render, staticRenderFns } from "./TemplateMultiSectionCatalog.vue?vue&type=template&id=d97610ee&scoped=true"
import script from "./TemplateMultiSectionCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateMultiSectionCatalog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TemplateMultiSectionCatalog.vue?vue&type=style&index=0&id=d97610ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97610ee",
  null
  
)

export default component.exports